import { defineStore } from "pinia"

export const useSnackbarStore = defineStore("snackbar", {
  state: () => ({
    show: false,
    text: "",
    color: "",
    timeout: 3000,
  }),
  actions: {
    addError(text: string) {
      this.$patch({
        show: true,
        text,
        color: "error",
        timeout: 5000,
      })
    },

    addSuccess(text: string) {
      this.$patch({
        show: true,
        text,
        color: "success",
        timeout: 5000,
      })
    },
    addInfo(text: string) {
      this.$patch({
        show: true,
        text,
        color: "info",
        timeout: 3000,
      })
    },
  },
})
